import { Pipe, PipeTransform, inject } from '@angular/core';
import { HisBaseGlobalsService } from '../service/base/his-base-globals.service';

@Pipe( {
    name: 'hisLowerCaseFirstLetter',
    standalone: false
} )
export class HisLowercasefirstletterPipe implements PipeTransform {
    private hisBaseGlobalsService = inject(HisBaseGlobalsService);


    transform( text: string ): string {
        if (text && this.hisBaseGlobalsService.getLanguage().toLowerCase() !== 'de' ) {
            return text.substring( 0, 1 ).toLowerCase() + text.substring( 1 );
        }
        else {
            return text;
        }
    }
}
